export default __webpack_public_path__ + "static/media/SFMarketing.1c53f975.png";